import { apiManager } from './apiManager';

export const ourWorkApi = {
  getOurWork: async () => await apiManager.get('/dashboard/services/our-works'),
};
